












































import { Component, Inject, InjectReactive, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import TitleMixin from '@/mixins/title-mixin';
import FeedTankCorrectionsList from './components/corrections/FeedTankCorrectionsList.vue';
import FeedTankCorrectionAdd from './components/corrections/FeedTankCorrectionAdd.vue';
import FeedTankCorrectionSettings from './components/corrections/FeedTankCorrectionSettings.vue';
import AddFeedTankReferencePoint from './components/corrections/AddFeedTankReferencePoint.vue';
import FeedTankReferencePoints from './components/corrections/FeedTankReferencePoints.vue';
import { FeedCorrection, FeedTank } from '@/api';
import { isRadar } from '@/pages/account/products/feed/models/sensor-config';
import type { SensorType } from '@/pages/account/products/feed/models/sensor-config';

@Component({
	components: {
		FeedTankCorrectionAdd,
		FeedTankCorrectionsList,
		FeedTankCorrectionSettings,
		AddFeedTankReferencePoint,
		FeedTankReferencePoints,
	},
	methods: {
		isRadar,
	},
})
export default class FeedTankCorrections extends mixins(TitleMixin) {
	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank;

	@Inject('refreshFeedProduct')
	private refreshFeedProduct!: () => Promise<void>;

	public get sensorType(): SensorType {
		return this.feedTank?.sensorType ?? 'radar';
	}

	public savedCorrections: FeedCorrection[] = [];

	public parameters: Record<string, string | number | null> = {};
	public correction: Record<string, number | null> = {};

	public correctionsList?: FeedTankCorrectionsList;

	created(): void {
		this.syncParametersFromFeedTank();
	}

	@Watch('feedTank')
	public onFeedTankChange(): void {
		this.syncParametersFromFeedTank();
	}

	private syncParametersFromFeedTank(): void {
		setTimeout(() => {
			this.correctionsList = <FeedTankCorrectionsList>this.$refs.correctionsList;
		}, 1);

		const params = this.feedTank?.formulaParameters;
		this.parameters = params && typeof params === 'object' ? { ...params } : {};
		this.correction = {};
		Object.keys(this.parameters).forEach(key => {
			this.correction[key] = (<any>this.feedTank?.formulaCorrection ?? { [key]: 0 })[key] ?? 0;
		});
	}

	public async reloadCorrectionList(
		correctionsSettings?: FeedTankCorrectionSettings,
		reloadFromApi: boolean = false,
	): Promise<void> {
		await this.correctionsList?.loadCorrections(reloadFromApi);

		await correctionsSettings?.updateTank();
	}

	/** After strain form submit (e.g. new reference point): refresh product so reference points table updates. */
	public async onStrainUpdate(): Promise<void> {
		await this.reloadCorrectionList(undefined, true);
		if (typeof this.refreshFeedProduct === 'function') {
			await this.refreshFeedProduct();
		}
	}
}
